module.exports = __webpack_public_path__ + "680e39e4f922dbf160a9f84fba264a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/history/9.jpg
// module id = 335
// module chunks = 0